import { Dialog, styled, Text } from "tamagui";

import { FileInput, FilePicker } from "../../ui/file-picker";
import { TextAreaWithLabel } from "../../ui/textarea";

const BagReportDialogContent = styled(Dialog.Content, {
  name: "BagReportDialogContent",
  borderColor: "$gray-600",
  borderWidth: "$0.2",
  borderRadius: "$5",

  variants: {
    media: {
      lg: {
        paddingVertical: "$5",
        paddingHorizontal: "$8",
        maxWidth: 636,
      },
      md: {
        paddingVertical: "$3",
        paddingHorizontal: "$2",
        maxWidth: 382,
      },
    },
  },
});

const BagReportDialogTitle = styled(Dialog.Title, {
  name: "BagReportDialogTitle",

  fontFamily: "$subtitle",
  color: "$gray-primary-900",
  fontWeight: "$6",
  variants: {
    font: {
      lg: {
        fontSize: "$4",
        lineHeight: "$4",
      },
      md: {
        fontSize: "$2",
        lineHeight: "$2",
      },
    },
  } as const,
  defaultVariants: {
    font: "lg",
  },
});

const BagReportDialogDescription = styled(Text, {
  name: "BagReportDialogDescription",
  fontFamily: "$body",
  color: "$gray-primary-900",
  fontWeight: "$4",
  fontSize: "$3",
  lineHeight: "$3",
});

//TOD0: use BlurView from expo-blur to enable blur on native platforms
const BagReportDialogOverlay = styled(Dialog.Overlay, {
  backgroundColor: "#6A696966",
  backdropFilter: "blur(10px)",
});

export const BagReportDialog = {
  Content: BagReportDialogContent,
  Title: BagReportDialogTitle,
  Description: BagReportDialogDescription,
  Overlay: BagReportDialogOverlay,
  FileInput,
  FilePicker,
  TextAreaWithLabel,
};
